<template>
  <input
    :id="id"
    v-bind="$attrs"
    ref="elRef"
    v-model="model"
    :placeholder="$t(props.placeholder)"
    :autocomplete="props.autocomplete ?? undefined"
    class="form__input"
    :class="{ 'is-invalid': validationUtils?.invalid }"
    type="text"
    @blur="onBlur($event)"
  />
</template>

<script lang="ts" setup>
import { computed, ComputedRef, inject, ref } from "vue";
import { ValidationUtils } from "@/types";

const props = defineProps<{
  autocomplete: string | null;
  modelValue: string;
  placeholder: string;
}>();

const elRef = ref<HTMLInputElement>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const validationUtils =
  inject<ComputedRef<ValidationUtils>>("field-validation");
const id = inject<string>("field-id");

const model = computed({
  get: () => props.modelValue ?? "",
  set: (input: string) => {
    const value = input.trim();
    emit("update:modelValue", value);
    validationUtils?.value.onChange(value);
  },
});

const onBlur = (event: FocusEvent) => {
  const input = event.target as HTMLInputElement;
  if (input.value.trim() !== input.value) {
    input.value = input.value.trim();
  }

  validationUtils?.value.touch();
};

const focus = () => elRef.value?.focus();

defineExpose({
  focus,
});
</script>
